import { useEffect } from 'react';
import { useBrand } from '../Brand';
import { useTranslation } from '../i18n';
import type { Translations } from '../i18n';

/**
 * Título da aba, por página.
 *
 * O legado montava `{{ $brand['name'] }}` na home, `"… - Escolha seu Plano"` na
 * lista e `"… - Cartão de Crédito"` no checkout. Aqui o sufixo vem do campo
 * `title` da página em `mainpage.json`, que é uma **chave do dicionário**
 * (ex.: `plans.pageTitle`) — não texto cru, para não furar a regra de i18n.
 *
 * O Fluxo A não usa este hook: lá o título é o nome da operadora, escrito pelo
 * próprio `LegacyPayment`.
 */
function resolveKey(translations: Translations, path?: string): string | null {
  if (!path) return null;
  const value = path
    .split('.')
    .reduce<unknown>(
      (acc, key) =>
        acc && typeof acc === 'object' ? (acc as Record<string, unknown>)[key] : undefined,
      translations
    );
  return typeof value === 'string' ? value : null;
}

export function usePageTitle(titleKey?: string): void {
  const { identity } = useBrand();
  const { t } = useTranslation();

  useEffect(() => {
    const brandName = identity.nomeFantasia || 'Recarga Fácil';
    const suffix = resolveKey(t, titleKey);
    document.title = suffix ? `${brandName} - ${suffix}` : brandName;
  }, [identity.nomeFantasia, t, titleKey]);
}
